const decentralandRedeemedInfoStyles = {
  card: {
    marginTop: 2,
  },
};

export default decentralandRedeemedInfoStyles;
